import axios from 'axios';

export const n8nApiWebhook ={
    envioMensaje: async(telefono,mensaje,tipoMensaje,archivo,nameUser) =>{
        console.log("envio mensaje",telefono,mensaje,tipoMensaje);
        try{
            const url = 'https://pruebas-abdres-n8n.46fbym.easypanel.host/webhook/ab96e947-2f86-4494-a577-fef0859c0dba';
            
            const formData = new FormData();
            formData.append('telefono', telefono);
            formData.append('mensaje', mensaje);
            formData.append('tipo_mensaje', tipoMensaje);
            formData.append('nameUser', nameUser);

            //append archivo
            if (archivo) {
                formData.append('archivo', archivo);
            }

            const response = await fetch(url, {
                method: 'POST',
                body: formData // El navegador/entorno establecerá automáticamente el Content-Type a multipart/form-data.
            });

             if (!response.ok) {
                // Si la respuesta no es exitosa (ej. status 400 o 500), lanzar un error.
                throw new Error(`Error en la solicitud: ${response.status} ${response.statusText}`);
            }

            const resultado = await response.json();

            console.log('Mensaje enviado con éxito:', resultado);
            return resultado; // Opcional: retornar el resultado.

        }
        catch(error){
            console.error('Falló el envío del mensaje:', error);
        }
    }
}